import chroma from 'chroma-js';
import { css } from 'styled-components';

export const headerHeight = `72px`;

export const clearFix = css`
  &:after {
    display: table;
    clear: both;
    content: '';
  }
`;

export const noAnimation = { display: 'block' };
export const startAnimation = { opacity: 0 };
export const endAnimation = { opacity: 1 };

export const institutionLogoWidth = '40px';

export const busyBackground = function(backgroundColor) {
  backgroundColor = backgroundColor || lightGrey2Color;
  return css`
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: ${`linear-gradient(to right, ${backgroundColor
      .brighten(1)
      .hex()} 8%, ${backgroundColor.hex()} 18%, ${backgroundColor.brighten(1).hex()} 33%)`};
    background-size: 1000px 104px;
  `;
};

export const spinAnimation = css`
  animation: spin 1s linear infinite;
`;

export const primaryColor = chroma('#2e2ed2'); //0875e3
export const googleColor = chroma('#cc0000');

export const blueColor = primaryColor;
export const lightBlueColor = chroma('#87cefa'); //83b9f0
export const lightBlue1Color = chroma('#daf1fe'); //new color
export const greenColor = chroma('#27c441');
export const lightGreenColor = chroma('#86e2b1');
export const redColor = chroma('#ff4040'); //ed1c24
export const yellowColor = chroma('#fef633'); //new color
export const darkGreyColor = chroma('#333333');
export const mediumGreyColor = chroma('#808080');
export const lightGrey3Color = chroma('#b3b3b3');
export const lightGrey2Color = chroma('#cccccc');
export const lightGrey1Color = chroma('#f2f2f2'); //shell white
export const adminPanelColor = chroma('#eff9ff');

export const buttonColor = primaryColor;
export const purplebuttonColor = chroma('#6118f2'); //8b4ce3
export const greyButtonColor = chroma('#4b6281');
export const greenButtonColor = chroma('#53c415');

export const greyColor = chroma('#e6e6e6');

export const gutterSize = '2rem';
export const smallContainerSize = '730px';

export const boxShadow = '0 0 5px rgba(0,0,0,0.3)';

export const extendedContentWidth = `${16 * 42}px`;

export const colorsV2 = {
  lightGreen: chroma('#ddf2e9'),
  darkBlue: chroma('#0A0148'),
};

export const device = {
  mobile: '480px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1200px',
};
